import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  NativeSelect,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import Footer from "../../components/footer";
import GlobalHeader from "../../components/header";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import AbcIcon from "@mui/icons-material/Abc";
import AddIcon from "@mui/icons-material/Add";
import GalleryProfile from "../../components/GalleryProfile";
import useApi from "../../hooks/useApi";
import useSnack from "../../hooks/useSnack";
import SnackAlert from "../../components/SnackAlert";
import { LoadingButton } from "@mui/lab";
import EuroIcon from "@mui/icons-material/Euro";
import NumbersIcon from "@mui/icons-material/Numbers";
import CheckSentProject from "../../components/CheckSentProject";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { KingBed } from "@mui/icons-material";

function NewProperty() {
  const CreateProperty = async () => {
    setIsLoading(true);
    loadApi("superadmin/states", true, "post", { ...prevCreateData }, true)
      .then((response) => {
        setPrevCreateData({
          name: "",
          information: "",
          price: "",
          purpose_use: "",
          type: "",
          location: "",
          m2: "",
          bedrooms: "",
          bathrooms: "",
          gallery: [],
          photo_profile: null,
        });
        setPreviewPicture(false);
        setGalleryPreview([]);
        showSnack(response.data.message, "success");
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setIsLoading(false));
  };

  // UTILS
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  // STATES AND DATA
  const [prevCreateData, setPrevCreateData] = useState({
    name: "",
    information: "",
    price: "",
    purpose_use: "",
    type: "",
    location: "",
    m2: "",
    bedrooms: "",
    bathrooms: "",
    gallery: [],
    photo_profile: null,
  });
  const [previewPicture, setPreviewPicture] = useState(false);
  const [galleryPreview, setGalleryPreview] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [messageCheck, setMessageCheck] = useState(false);
  const fileInputPhoto = useRef(null);
  const fileGallery = useRef(null);
  const purpose_list = ["Venta", "Arriendo"];
  const types_list = ["Casa", "Apartamento"];

  const handlerAddGalleryImage = (e) => {
    if (galleryPreview.length === 10) {
      showSnack("No se pueden agregar más de 10 imágenes");
      return;
    }

    const files = e.target.files;
    for (const file of files) {
      const reader = new FileReader();
      setPrevCreateData({
        ...prevCreateData,
        gallery: [...prevCreateData.gallery, file],
      });
      reader.onloadend = () => {
        setGalleryPreview([
          ...galleryPreview,
          { url: reader.result, name: file.name },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlerChangePreviewImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPrevCreateData({ ...prevCreateData, photo_profile: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewPicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  const areThereEmptyFields = (data) => {
    let result = false;

    const fieldsString = [
      "name",
      "information",
      "price",
      "purpose_use",
      "type",
      "location",
      "m2",
      "bedrooms",
      "bathrooms",
    ];

    for (const field of fieldsString) {
      if (
        data.hasOwnProperty(field) &&
        data[field].trim &&
        data[field].trim() === ""
      ) {
        result = true;
      }
    }

    if (Array.isArray(data.gallery) && data.gallery.length === 0) {
      result = true;
    }

    if (data.hasOwnProperty("photo_profile") && data.photo_profile === null) {
      result = true;
    }

    return result;
  };

  const handlerSendProperty = () => {
    const thereAreEmptyFields = areThereEmptyFields(prevCreateData);
    if (thereAreEmptyFields) {
      showSnack("Debe llenar todos los campos");
      return;
    }
    CreateProperty();
  };

  useEffect(() => {
    document.title = "Invirte | Crear Inmueble";
  }, []);

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Stack px={2}>
          {messageCheck ? (
            <CheckSentProject type="property" />
          ) : (
            <>
              <Typography component="h1" variant="h4" mb={4}>
                Nuevo inmueble
              </Typography>
              <Stack flexDirection={{ xs: "column", md: "row" }} gap={5} mb={4}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  component="article"
                  sx={{
                    boxShadow: previewPicture
                      ? "-6px 5px 8px -1px rgba(0,0,0,0.31)"
                      : "none",
                    cursor: "pointer",
                    width: { xs: "100%", md: "40%" },
                    height: { xs: 250, md: 270 },
                    border: "1px solid gray",
                    borderRadius: 2,
                  }}
                  onClick={() => fileInputPhoto.current.click()}
                >
                  {!!previewPicture ? (
                    <img
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover", borderRadius: 8 }}
                      src={previewPicture}
                    />
                  ) : (
                    <AddAPhotoIcon
                      sx={{ color: "#87878757" }}
                      fontSize="large"
                    />
                  )}
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .png, .jpeg, .webp"
                    ref={fileInputPhoto}
                    onChange={handlerChangePreviewImage}
                  />
                </Stack>
                <Stack
                  gap={1.5}
                  sx={{
                    width: { xs: "100%", md: "60%" },
                  }}
                >
                  <Typography component="h3" variant="h6">
                    Básico
                  </Typography>
                  <TextField
                    label="Título"
                    fullWidth
                    value={prevCreateData.name}
                    onChange={({ target }) => {
                      if (target.value.length > 40) {
                        showSnack(
                          "El título solo puede tener un máximo de 40 caracteres"
                        );
                        return;
                      }
                      setPrevCreateData({
                        ...prevCreateData,
                        name: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Ubicación de inmueble"
                    value={prevCreateData.location}
                    onChange={({ target }) => {
                      if (target.value.length > 40) {
                        showSnack(
                          "La ubicación solo puede tener un máximo de 40 caracteres"
                        );
                        return;
                      }
                      setPrevCreateData({
                        ...prevCreateData,
                        location: target.value,
                      });
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Precio"
                    type="text"
                    value={formatNumberWithDots(prevCreateData.price)}
                    fullWidth
                    onChange={({ target }) => {
                      if (target.value.startsWith("0")) {
                        showSnack("El precio no puede ser cero");
                        return;
                      }
                      if (target.value.startsWith("-")) {
                        showSnack("El precio no puede ser negativo");
                        return;
                      }
                      let result = handleChange(target.value);
                      if (/^\d*$/.test(result)) {
                        result = result.slice(0, 10);

                        setPrevCreateData({
                          ...prevCreateData,
                          price: result,
                        });
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <EuroIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
              </Stack>
              <Stack>
                <Typography component="h3" variant="h6" mb={2}>
                  Información de inmueble
                </Typography>
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                  mb={2}
                >
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="demo-multiple-name-label">
                      Tipo de inmueble
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={prevCreateData.type}
                      onChange={({ target }) => {
                        setPrevCreateData({
                          ...prevCreateData,
                          type: target.value,
                        });
                      }}
                      input={<OutlinedInput label="Tipo de inmueble" />}
                    >
                      {(types_list || []).map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="demo-multiple-name-label">
                      Propósito de uso
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      value={prevCreateData.purpose_use}
                      onChange={({ target }) => {
                        setPrevCreateData({
                          ...prevCreateData,
                          purpose_use: target.value,
                        });
                      }}
                      input={<OutlinedInput label="Propósito de uso" />}
                    >
                      {(purpose_list || []).map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                  mb={2}
                >
                  <TextField
                    label="Número de habitaciones"
                    value={prevCreateData.bedrooms}
                    onChange={({ target }) => {
                      const inputValue = target.value;
                      if (inputValue.startsWith("0") && inputValue.length > 1) {
                        showSnack(
                          "El número de habitaciones no puede empezar con cero"
                        );
                        return;
                      }
                      if (inputValue.startsWith("-")) {
                        showSnack(
                          "El número de habitaciones no puede ser negativo"
                        );
                        return;
                      }
                      if (inputValue.length > 3) {
                        showSnack(
                          "El número de habitaciones no puede tener más de 3 dígitos"
                        );
                        return;
                      }
                      setPrevCreateData({
                        ...prevCreateData,
                        bedrooms: inputValue,
                      });
                    }}
                    fullWidth
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <KingBed />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Número de baños"
                    value={prevCreateData.bathrooms}
                    onChange={({ target }) => {
                      const inputValue = target.value;
                      if (inputValue.startsWith("0") && inputValue.length > 1) {
                        showSnack(
                          "El número de baños no puede empezar con cero"
                        );
                        return;
                      }
                      if (inputValue.startsWith("-")) {
                        showSnack("El número de baños no puede ser negativo");
                        return;
                      }
                      if (inputValue.length > 3) {
                        showSnack(
                          "El número de baños no puede tener más de 3 dígitos"
                        );
                        return;
                      }
                      setPrevCreateData({
                        ...prevCreateData,
                        bathrooms: inputValue,
                      });
                    }}
                    type="number"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <BathtubIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Box
                  mb={4}
                  display="flex"
                  flexDirection={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  gap={3}
                >
                  <TextField
                    label="Descripción del inmueble"
                    fullWidth
                    value={prevCreateData.information}
                    onChange={({ target }) => {
                      if (target.value.length > 730) {
                        showSnack(
                          "La ubicación solo puede tener un máximo de 730 caracteres"
                        );
                        return;
                      }
                      setPrevCreateData({
                        ...prevCreateData,
                        information: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Metros Cuadrados"
                    fullWidth
                    value={prevCreateData.m2}
                    onChange={({ target }) => {
                      if (target.value.startsWith("0")) {
                        showSnack("Los metros cuadrados no pueden ser cero");
                        return;
                      }
                      if (target.value.startsWith("-")) {
                        showSnack(
                          "Los metros cuadrados no pueden ser negativos"
                        );
                        return;
                      }
                      if (/^\d*$/.test(target.value)) {
                        const limitedValue = target.value.slice(0, 10);
                        setPrevCreateData({
                          ...prevCreateData,
                          m2: limitedValue,
                        });
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AspectRatioIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Stack>
              <Stack mb={2}>
                <Stack flexDirection="row" alignItems="center" mb={2}>
                  <Typography component="h3" variant="h6" mr={2}>
                    Imágenes del inmueble
                  </Typography>
                  <IconButton
                    onClick={() => fileGallery.current.click()}
                    size="small"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      "&:hover": { backgroundColor: "primary.300" },
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>

                  <input
                    onChange={handlerAddGalleryImage}
                    style={{ display: "none" }}
                    type="file"
                    accept=".jpg, .png, .jpeg, .webp"
                    ref={fileGallery}
                  />
                </Stack>
                <GalleryProfile
                  setGalleryImages={setGalleryPreview}
                  data={galleryPreview}
                  mainData={prevCreateData}
                  setDataProfile={setPrevCreateData}
                />
              </Stack>
              <LoadingButton
                type="submit"
                loading={isLoading}
                onClick={handlerSendProperty}
                sx={{
                  width: "fit-content",
                  mb: 5,
                  px: 3,
                  py: 1.5,
                  borderRadius: 5,
                  color: "white",
                  marginInline: "auto",
                  "&:hover": {
                    backgroundColor: "primary.300",
                  },
                }}
              >
                CREAR INMUEBLE
              </LoadingButton>
            </>
          )}
        </Stack>
      </Stack>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />

      {/* <Footer /> */}
    </>
  );
}

export default NewProperty;
